import orderTranslationsHelper from "../../../../../../languages/order-translations.helper";
import { OrderAbandonedListingPublicStatusesTranslations } from "../../../../../../languages/types/order/order-abandoned-listing.translation";
import OrderCargoOrderAbandonedDownloadResponse from "../../../../../api/raily/order/cargo-order/abandoned/download/order-cargo-order-abandoned-download.response";
import PublicStatus from "../../../../../types/public-status";
import OrderCargoOrderAbandonedDownload from "./order-cargo-order-abandoned-download";

const createPublicStatus = (
  publicStatus: PublicStatus,
  publicStatusesTranslations: OrderAbandonedListingPublicStatusesTranslations,
): string => {
  switch (publicStatus) {
    case PublicStatus.PRIVATE:
      return publicStatusesTranslations.private;
    case PublicStatus.PUBLIC:
      return publicStatusesTranslations.public;
    case PublicStatus.PUBLISHED:
      return publicStatusesTranslations.published;
    default:
      return "undefined";
  }
};

const create = (
  response: OrderCargoOrderAbandonedDownloadResponse,
): OrderCargoOrderAbandonedDownload => {
  const translations =
    orderTranslationsHelper.getAbandonedListingTranslations().publicStatuses;

  let reportContent = response.data;

  Object.values(PublicStatus).forEach((publicStatus) => {
    reportContent = reportContent.replace(
      new RegExp(`${publicStatus}`, "g"),
      createPublicStatus(publicStatus, translations),
    );
  });

  return {
    data: new Blob([reportContent], { type: "text/csv;charset=utf8" }),
    filename: "",
  };
};

const orderCargoOrderAbandonedDownloadFactory = {
  create,
};

export default orderCargoOrderAbandonedDownloadFactory;
